import { Router } from "express";
import { PermissionController } from "../controllers/permission.controller";
import { Routes } from "../../../interface/routes.interface";
import { permissionInjector } from "../../../middlewares/permissionInjector";

export class permissionRouter implements Routes {
    public router = Router();
    public permissionController = new PermissionController();
    public path = '/permission'



    constructor() {
        this.initializeRoutes();

    }
    public initializeRoutes() {

        this.router.post(`${this.path}/`, permissionInjector(`${this.path}`, 'POST'), this.permissionController.createPermission);
        this.router.get(`${this.path}/:id`, permissionInjector(`${this.path}`, 'GET'), this.permissionController.getPermissionById);
        this.router.get(`${this.path}/`, permissionInjector(`${this.path}`, 'GET'), this.permissionController.getAllPermissions);
        this.router.put(`${this.path}/:id`, permissionInjector(`${this.path}`, 'PUT'), this.permissionController.updatePermission);
        this.router.delete(`${this.path}/:id`, permissionInjector(`${this.path}`, 'DELETE'), this.permissionController.deletePermission);
    }
}
